<template >
  <div id="parentx">
    <vs-sidebar
      v-if="
        this.$route.path !== '/login' &&
        this.$route.path !== '/register' &&
        this.$route.path !== '/Resetpassword' &&
        this.$route.path !== '/login2'
      "
      default-index="1"
      :parent="parent"
      :hiddenBackground="doNotClose"
      class="sidebarx"
      spacer
      v-model="isSidebarActive"
      :click-not-close="doNotClose"
    >
      <vs-sidebar-group
        v-if="this.username === 'betagrodemo' || this.admin == 'betagrodemo'"
        title="Sensor Tracking"
        open
      >
        <vs-sidebar-item :to="'IndoorDashboard'" index="3" icon="dashboard">
          Dashboard
        </vs-sidebar-item>
        <vs-sidebar-item :to="'IndoorOverview'" index="1" icon="cloud_queue">
          Overview
        </vs-sidebar-item>
        <vs-sidebar-item :to="'IndoorReport'" index="2" icon="description">
          Report
        </vs-sidebar-item>

        <vs-sidebar-group title="Device Mangement">
          <vs-sidebar-item :to="'IndoorSensor'" index="2.1" icon="contactless">
            Sensor
          </vs-sidebar-item>

          <vs-sidebar-item :to="'IndoorGateway'" index="2.3" icon="router">
            Gateway
          </vs-sidebar-item>
          <vs-sidebar-item
            :to="'IndoorAlert'"
            index="2.3"
            icon="report_problem"
          >
            Alert
          </vs-sidebar-item>
        </vs-sidebar-group>

        <!-- <vs-sidebar-group v-if="this.username==='pttdemo'" title="Real-time Resource Tracking">
        <vs-sidebar-item :to="'IndoorOverview'" index="1" icon="cloud_queue">
          Daily Resource Status
        </vs-sidebar-item>
        <vs-sidebar-item :to="'IndoorReport'" index="2" icon="description">
          Resource Status Report
        </vs-sidebar-item> 
        <vs-sidebar-item :to="'IndoorDashboard'" index="3" icon="dashboard">
          IoT Dashboard
        </vs-sidebar-item>

        <vs-sidebar-group v-if="this.username==='pttdemo'" title="Device Mangement">
          <vs-sidebar-item :to="'IndoorTag'" index="2.1" icon="loyalty">
            Worker Tag
          </vs-sidebar-item>
          <vs-sidebar-item :to="'IndoorEsset'" index="2.2" icon="settings_remote">
            Asset Tag
          </vs-sidebar-item>
          <vs-sidebar-item :to="'IndoorGateway'" index="2.3" icon="router">
            Gateway
          </vs-sidebar-item>
          
        </vs-sidebar-group> -->

        <vs-sidebar-group title="Setting">
          <vs-sidebar-item
            :to="'IndoorAlertSetting'"
            index="2.1"
            icon="new_releases"
          >
            Alert Setting
          </vs-sidebar-item>
        </vs-sidebar-group>
      </vs-sidebar-group>

      <vs-sidebar-group
        v-else-if="this.username === 'syntecdemo'"
        title="Real-time Resource Tracking"
        open
      >
        <vs-sidebar-item :to="'IndoorOverview'" index="1" icon="cloud_queue">
          Daily Resource Status
        </vs-sidebar-item>
        <vs-sidebar-item :to="'IndoorReport'" index="2" icon="description">
          Resource Status Report
        </vs-sidebar-item>
        <vs-sidebar-item :to="'IndoorDashboard'" index="3" icon="dashboard">
          Resource Dashboard
        </vs-sidebar-item>
        <vs-sidebar-item :to="'thingsboard'" index="3" icon="stream">
          Sensor Dashboard
        </vs-sidebar-item>
        <!-- <vs-sidebar-item :to="'3dtest'" index="3" icon="3d_rotation">
          3D model
        </vs-sidebar-item> -->
        <vs-sidebar-group title="Resource Mangement">
          <vs-sidebar-item :to="'IndoorTag'" index="2.1" icon="loyalty">
            Worker Tag
          </vs-sidebar-item>
          <vs-sidebar-item :to="'IndoorGateway'" index="2.3" icon="router">
            Gateway
          </vs-sidebar-item>
        </vs-sidebar-group>
      </vs-sidebar-group>

      <vs-sidebar-group
        v-else-if="this.username === 'unicorndemo'"
        title="Stock Tracking Management"
        open
      >
        <vs-sidebar-item :to="'IndoorOverview'" index="1" icon="cloud_queue">
          Daily Stock Status
        </vs-sidebar-item>
        <vs-sidebar-item :to="'IndoorReport'" index="2" icon="description">
          Stock Report
        </vs-sidebar-item>
        <vs-sidebar-item :to="'Stock-DashBoard'" index="3" icon="dashboard">
          Stock Dashboard
        </vs-sidebar-item>

        <!-- <vs-sidebar-item :to="'3dtest'" index="3" icon="3d_rotation">
          3D model
        </vs-sidebar-item> -->
        <vs-sidebar-group title="Resource Mangement">
          <vs-sidebar-item
            :to="'IndoorEsset'"
            index="2.1"
            icon="settings_remote"
          >
            Asset
          </vs-sidebar-item>
          <vs-sidebar-item :to="'IndoorGateway'" index="2.3" icon="router">
            Gateway
          </vs-sidebar-item>
        </vs-sidebar-group>
        <vs-sidebar-group title="Alert Mangement">
          <vs-sidebar-item :to="'StockAlert'" index="2.1" icon="report_problem">
            Alert Status
          </vs-sidebar-item>
        </vs-sidebar-group>
      </vs-sidebar-group>

      <vs-sidebar-group
        v-else-if="this.username === 'kubotademo'"
        title="Farm Environment Tracking"
        open
      >
        <vs-sidebar-item :to="'Overview'" index="1" icon="cloud_queue">
          Overview
        </vs-sidebar-item>
        <vs-sidebar-item :to="'Report'" index="2" icon="description">
          Report
        </vs-sidebar-item>

        <vs-sidebar-item :to="'kubotafarm'" index="3" icon="dashboard">
          Farm Dashboard
        </vs-sidebar-item>
        <vs-sidebar-group title="Device Mangement">
          <vs-sidebar-item :to="'Sensor'" index="2.2" icon="settings_remote">
            Device
          </vs-sidebar-item>
          <vs-sidebar-item :to="'Gateway'" index="2.3" icon="router">
            Gateway
          </vs-sidebar-item>
        </vs-sidebar-group>
      </vs-sidebar-group>

      <vs-sidebar-group
        v-else-if="this.username === 'yamahaaqidemo'"
        title="Environment Monitor"
        open
      >
        <vs-sidebar-item :to="'Overview'" index="1" icon="cloud_queue">
          Overview
        </vs-sidebar-item>
        <vs-sidebar-item :to="'Report'" index="2" icon="description">
          Report
        </vs-sidebar-item>

        <vs-sidebar-item :to="'aqidashboard'" index="3" icon="dashboard">
          Environment Dashboard
        </vs-sidebar-item>
        <vs-sidebar-group title="Device Mangement">
          <vs-sidebar-item
            :to="'IndoorEsset'"
            index="2.2"
            icon="settings_remote"
          >
            Device
          </vs-sidebar-item>
          <vs-sidebar-item :to="'IndoorGateway'" index="2.3" icon="router">
            Gateway
          </vs-sidebar-item>
        </vs-sidebar-group>
      </vs-sidebar-group>

      <vs-sidebar-group
        v-else-if="this.username === 'awcdemo'"
        title="Asset World"
        open
      >
        <vs-sidebar-group title="Sentenance">
          <vs-sidebar-item
            :to="'AssetWorldDashboard'"
            index="2.2"
            icon="cloud_queue"
          >
            Overview
          </vs-sidebar-item>
        </vs-sidebar-group>
      </vs-sidebar-group>

      <vs-sidebar-group
        v-else-if="this.username === 'VSteeldemo'"
        title="Process Monitor"
        open
      >
        <vs-sidebar-item :to="'/Overview'" index="1" icon="cloud_queue">
          Overview
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/Report'" index="2" icon="description">
          Report
        </vs-sidebar-item>
        <vs-sidebar-group title="Dashboard Monitor" open>
          <vs-sidebar-item
            :to="{ name: 'v-steel', params: { place: 'vsteel1' } }"
            index="3"
            icon="dashboard"
          >
            Maxsale
          </vs-sidebar-item>
          <vs-sidebar-item
            :to="{ name: 'v-steel', params: { place: 'vsteel2' } }"
            index="3"
            icon="dashboard"
          >
            วี-บิ้วท์ ลำลูกกา
          </vs-sidebar-item>
          <vs-sidebar-item :to="'/v-steel/vsteel4'" index="3" icon="dashboard">
            V-Steel Metal Supply
          </vs-sidebar-item>
          <vs-sidebar-item :to="'/v-steel/vsteel4'" index="3" icon="dashboard">
            ที-วัน วังน้อย
          </vs-sidebar-item>
          <vs-sidebar-item :to="'/v-steel/vsteel3'" index="3" icon="dashboard">
            วี-สตีล อยุธยา
          </vs-sidebar-item>
        </vs-sidebar-group>
        <vs-sidebar-group title="Device Mangement">
          <vs-sidebar-item :to="'/sensor'" index="2.2" icon="settings_remote">
            Device
          </vs-sidebar-item>
          <vs-sidebar-item :to="'/gateway'" index="2.3" icon="router">
            Gateway
          </vs-sidebar-item>
        </vs-sidebar-group>
      </vs-sidebar-group>

      <vs-sidebar-group
        v-else-if="this.username === 'i-APCdemo'"
        title="Real-time Tracking"
        open
      >
        <vs-sidebar-item :to="'/Overview'" index="1" icon="cloud_queue">
          Daily Resource Status
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/report'" index="2" icon="description">
          Resource Status Report
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/I-APC-RM'" index="3" icon="dashboard">
          Resource Dashboard
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/I-APC'" index="3" icon="stream">
          Sensor Dashboard
        </vs-sidebar-item>
        <!-- <vs-sidebar-item :to="'3dtest'" index="3" icon="3d_rotation">
          3D model
        </vs-sidebar-item> -->
        <vs-sidebar-group title="Resource Mangement">
          <vs-sidebar-item :to="'/RFIDTag'" index="2.1" icon="loyalty">
            Worker Tag
          </vs-sidebar-item>
        </vs-sidebar-group>
        <vs-sidebar-group title="Sensor Mangement">
          <vs-sidebar-item :to="'Sensor'" index="2.1" icon="loyalty">
            Sensor
          </vs-sidebar-item>
          <vs-sidebar-item :to="'Gateway'" index="2.3" icon="router">
            Gateway
          </vs-sidebar-item>
        </vs-sidebar-group>
      </vs-sidebar-group>

      <vs-sidebar-group
        v-else-if="this.username === 'pttdemo'"
        title="Real-time Resource Tracking"
      >
        <vs-sidebar-item :to="'IndoorOverview'" index="1" icon="cloud_queue">
          Daily Resource Status
        </vs-sidebar-item>
        <vs-sidebar-item :to="'IndoorReport'" index="2" icon="description">
          Resource Status Report
        </vs-sidebar-item>
        <vs-sidebar-item :to="'IndoorDashboard'" index="3" icon="dashboard">
          IoT Dashboard
        </vs-sidebar-item>
        <vs-sidebar-group title="Device Mangement">
          <vs-sidebar-item :to="'IndoorTag'" index="2.1" icon="loyalty">
            Worker Tag
          </vs-sidebar-item>
          <vs-sidebar-item
            :to="'IndoorEsset'"
            index="2.2"
            icon="settings_remote"
          >
            Asset Tag
          </vs-sidebar-item>
          <vs-sidebar-item :to="'IndoorGateway'" index="2.3" icon="router">
            Gateway
          </vs-sidebar-item>
        </vs-sidebar-group>
      </vs-sidebar-group>

      <vs-sidebar-group
        v-else-if="
          this.username === 'Rivacold01' || this.admin === 'Rivacold01'
        "
        title="Temperature Tracking"
        open
      >
        <vs-sidebar-item :to="'IndoorOverview'" index="1" icon="cloud_queue">
          Overview
        </vs-sidebar-item>
        <vs-sidebar-item :to="'IndoorReport'" index="2" icon="description">
          Report
        </vs-sidebar-item>
        <vs-sidebar-item :to="'locationdashboard'" index="3" icon="room">
          Location
        </vs-sidebar-item>

        <vs-sidebar-group title="Device Mangement">
          <vs-sidebar-item
            :to="'IndoorSensor'"
            index="2.2"
            icon="settings_remote"
          >
            Sensor
          </vs-sidebar-item>
          <vs-sidebar-item :to="'IndoorGateway'" index="2.3" icon="router">
            Gateway
          </vs-sidebar-item>
        </vs-sidebar-group>
        <vs-sidebar-group v-if="this.username == admin" title="Setting">
          <vs-sidebar-item :to="'locationsetting'" index="2.2" icon="explore">
            Location Setting
          </vs-sidebar-item>
        </vs-sidebar-group>
      </vs-sidebar-group>

      <vs-sidebar-group
        v-else-if="this.username === 'KPcooldemo'"
        title="Temperature Tracking"
        open
      >
        <vs-sidebar-item :to="'IndoorOverview'" index="1" icon="cloud_queue">
          Overview
        </vs-sidebar-item>
        <vs-sidebar-item :to="'IndoorReport'" index="2" icon="description">
          Report
        </vs-sidebar-item>
        <vs-sidebar-item :to="'KPCool'" index="3" icon="room">
          Dashboard
        </vs-sidebar-item>

        <vs-sidebar-group title="Device Mangement">
          <vs-sidebar-item
            :to="'IndoorSensor'"
            index="2.2"
            icon="settings_remote"
          >
            Sensor
          </vs-sidebar-item>
          <vs-sidebar-item :to="'IndoorGateway'" index="2.3" icon="router">
            Gateway
          </vs-sidebar-item>
        </vs-sidebar-group>
        <!-- <vs-sidebar-group  title="Setting">
          
          <vs-sidebar-item :to="'locationsetting'" index="2.2" icon="explore">
            Location Setting
          </vs-sidebar-item>
          
        </vs-sidebar-group> -->
      </vs-sidebar-group>

      <vs-sidebar-group
        v-else-if="this.username === 'yamahademo'"
        title="Sentenance"
        open
      >
        <vs-sidebar-item :to="'Overview'" index="1" icon="cloud_queue">
          Overview
        </vs-sidebar-item>
        <vs-sidebar-item :to="'dataExport'" index="2" icon="description">
          Report
        </vs-sidebar-item>
        <vs-sidebar-item :to="'mapdashboard'" index="3" icon="dashboard">
          Dashboard Overview
        </vs-sidebar-item>
        <vs-sidebar-group open title="Dashboard">
          <vs-sidebar-item :to="'PlasticPaintingWWTPplant'" index="2.1">
            <img
              style="width: 13.5%; height: 13.5%"
              src="@/assets/sidebarIcon/42.png"
            />
            Plastic Painting WWTP
          </vs-sidebar-item>
          <vs-sidebar-item :to="'AluminiumPaintingWWTPplant'" index="2.1">
            <img
              style="width: 13.5%; height: 13.5%"
              src="@/assets/sidebarIcon/38.png"
            />
            Aluminium Painting WWTP
          </vs-sidebar-item>
          <vs-sidebar-item :to="'dafplant'" index="2.1">
            <img
              style="width: 13.5%; height: 13.5%"
              src="@/assets/sidebarIcon/40.png"
            />
            DAF Plant
          </vs-sidebar-item>
          <vs-sidebar-item :to="'centerplant'" index="2.1">
            <img
              style="width: 13.5%; height: 13.5%"
              src="@/assets/sidebarIcon/39.png"
            />
            Center Plant
          </vs-sidebar-item>
          <vs-sidebar-item :to="'asplant'" index="2.1">
            <img
              style="width: 13.5%; height: 13.5%"
              src="@/assets/sidebarIcon/52.png"
            />
            AS Plant
          </vs-sidebar-item>
          <vs-sidebar-item :to="'mbrplant'" index="2.1">
            <img
              style="width: 13.5%; height: 13.5%"
              src="@/assets/sidebarIcon/53.png"
            />
            MBR Plant
          </vs-sidebar-item>
          <vs-sidebar-item :to="'recycleplant'" index="2.1">
            <img
              style="width: 13.5%; height: 13.5%"
              src="@/assets/sidebarIcon/51.png"
            />
            Recycle Plant
          </vs-sidebar-item>

          <vs-sidebar-item :to="'roplant'" index="2.1">
            <img
              style="width: 13.5%; height: 13.5%"
              src="@/assets/sidebarIcon/36.png"
            />
            RO Plant
          </vs-sidebar-item>
        </vs-sidebar-group>
        <vs-sidebar-group title="Device Mangement">
          <vs-sidebar-item :to="'sensor'" index="2.2" icon="settings_remote">
            Device
          </vs-sidebar-item>
          <vs-sidebar-item :to="'gateway'" index="2.3" icon="router">
            Gateway
          </vs-sidebar-item>
        </vs-sidebar-group>
        <vs-sidebar-group title="Setting">
          <vs-sidebar-item :to="'network'" index="2.2" icon="wifi">
            Network
          </vs-sidebar-item>
        </vs-sidebar-group>
      </vs-sidebar-group>

      <!-- && this.username !== 'pttdemo'" -->
      <div v-else-if="this.username !== 'yamahademo'">
        <div v-if="this.username !== 'kubotademo'">
          <div v-if="this.username !== 'i-APCdemo'">
            <div v-if="this.username !== 'syntecdemo'">
              <div v-if="this.username !== 'unicorndemo'">
                <div v-if="this.username !== 'VSteeldemo'">
                  <div v-if="this.username !== 'yamahaaqidemo'">
                    <div
                      v-if="
                        this.username !== 'Rivacold01' &&
                        this.admin !== 'Rivacold01'
                      "
                    >
                      <div v-if="this.username !== 'KPcooldemo'">
                        <!-- -->
                        <vs-sidebar-group
                          title="Indoor Tracking"
                          v-if="
                            sideindex[1] &&
                            this.username !== 'pttdemo' &&
                            this.username !== 'yamahademo'
                          "
                        >
                          <!-- <template v-for="(sidebarLink, index) in sidebarLinks.slice(sideindex[0], sideindex[1])"> -->
                          <template
                            v-for="(sidebarLink, index) in sidebarLinks.slice(
                              sideindex[10],
                              sideindex[11]
                            )"
                          >
                            <vs-sidebar-item
                              :icon="sidebarLink.icon"
                              :to="sidebarLink.url"
                              :key="`sidebarLink-${index}`"
                              :index="index"
                            >
                              <span class="hide-in-minisidebar" id="stfont">{{
                                sidebarLink.name
                              }}</span>
                            </vs-sidebar-item>
                          </template>

                          <vs-sidebar-group title="Device Management">
                            <template
                              v-for="(sidebarLink, index) in sidebarLinks.slice(
                                sideindex[11],
                                sideindex[13]
                              )"
                            >
                              <div :key="index">
                                <!-- <div v-if="username == 'betagrodemo'">
                <vs-sidebar-item
                  id="a"
                  v-if="
                    sidebarLink.name != 'Asset' && sidebarLink.name != 'Tag'
                  "
                  :icon="sidebarLink.icon"
                  :to="sidebarLink.url"
                  :key="`sidebarLink-${index}`"
                  :index="index"
                >
                  <span class="hide-in-minisidebar" id="stfont">{{
                    sidebarLink.name
                  }}</span>
                </vs-sidebar-item>
              </div> -->

                                <div v-if="username == 'camilliandemo'">
                                  <vs-sidebar-item
                                    v-if="
                                      sidebarLink.name != 'Sensor' &&
                                      sidebarLink.name != 'Tag' &&
                                      sidebarLink.name != 'Alert'
                                    "
                                    :icon="sidebarLink.icon"
                                    :to="sidebarLink.url"
                                    :key="`sidebarLink-${index}`"
                                    :index="index"
                                  >
                                    <span
                                      class="hide-in-minisidebar"
                                      id="stfont"
                                      >{{ sidebarLink.name }}</span
                                    >
                                  </vs-sidebar-item>
                                </div>

                                <div v-else-if="username == 'spartan'">
                                  <vs-sidebar-item
                                    v-if="
                                      sidebarLink.name != 'Sensor' &&
                                      sidebarLink.name != 'Tag' &&
                                      sidebarLink.name != 'Alert'
                                    "
                                    :icon="sidebarLink.icon"
                                    :to="sidebarLink.url"
                                    :key="`sidebarLink-${index}`"
                                    :index="index"
                                  >
                                    <span
                                      class="hide-in-minisidebar"
                                      id="stfont"
                                      >{{ sidebarLink.name }}</span
                                    >
                                  </vs-sidebar-item>
                                </div>

                                <div v-else-if="username == 'pttdemo'">
                                  <vs-sidebar-item
                                    v-if="
                                      sidebarLink.name != 'Sensor' &&
                                      sidebarLink.name != 'Alert'
                                    "
                                    :icon="sidebarLink.icon"
                                    :to="sidebarLink.url"
                                    :key="`sidebarLink-${index}`"
                                    :index="index"
                                  >
                                    <span
                                      class="hide-in-minisidebar"
                                      id="stfont"
                                      >{{ sidebarLink.name }}</span
                                    >
                                  </vs-sidebar-item>
                                </div>

                                <div v-else>
                                  <vs-sidebar-item
                                    :icon="sidebarLink.icon"
                                    :to="sidebarLink.url"
                                    :key="`sidebarLink-${index}`"
                                    :index="index"
                                  >
                                    <span
                                      class="hide-in-minisidebar"
                                      id="stfont"
                                      >{{ sidebarLink.name }}</span
                                    >
                                  </vs-sidebar-item>
                                </div>
                              </div>
                            </template>
                          </vs-sidebar-group>

                          <vs-sidebar-group title="Setting">
                            <vs-sidebar-item
                              v-for="(sidebarLink, index) in sidebarLinks.slice(
                                sideindex[13],
                                sideindex[14]
                              )"
                              :icon="sidebarLink.icon"
                              :to="sidebarLink.url"
                              :key="`sidebarLink-${index}`"
                              :index="index"
                            >
                              <span class="hide-in-minisidebar" id="stfont">{{
                                sidebarLink.name
                              }}</span>
                            </vs-sidebar-item>
                          </vs-sidebar-group>
                        </vs-sidebar-group>

                        <vs-sidebar-group
                          title="Overview"
                          v-if="username == 'frasers.kho'"
                          open
                        >
                          <vs-sidebar-item
                            :icon="'map'"
                            :to="'/mapOverview'"
                            :key="`sidebarLink-100`"
                            v-if="username == 'frasers.kho'"
                          >
                            <span class="hide-in-minisidebar" id="stfont">
                              Map Overview
                            </span>
                          </vs-sidebar-item>
                          <vs-sidebar-group
                            title="Dashboard"
                            v-if="username == 'frasers.kho'"
                          >
                            <vs-sidebar-item
                              v-for="(
                                sidebarLink, index
                              ) in sidebarLinks_dashboard"
                              :icon="sidebarLink.icon"
                              :to="sidebarLink.url"
                              :key="`sidebarLink-${index}`"
                              :index="index"
                            >
                              <span class="hide-in-minisidebar" id="stfont">{{
                                sidebarLink.name
                              }}</span>
                            </vs-sidebar-item>
                          </vs-sidebar-group>
                        </vs-sidebar-group>
                        <vs-sidebar-item
                          :icon="'show_chart'"
                          :to="'/graph'"
                          :key="`sidebarLink-100`"
                          v-if="username == 'frasers.kho'"
                        >
                          <span class="hide-in-minisidebar" id="stfont">
                            Graph Visualization
                          </span>
                        </vs-sidebar-item>
                        <vs-sidebar-group
                          v-if="this.username === 'swiftdemo'"
                          title="Indoor Tracking"
                          open
                        >
                          <vs-sidebar-item
                            :to="'IndoorOverview'"
                            index="1"
                            icon="cloud_queue"
                          >
                            Daily Resource Status
                          </vs-sidebar-item>
                          <vs-sidebar-item
                            :to="'IndoorReport'"
                            index="2"
                            icon="description"
                          >
                            Resource Status Report
                          </vs-sidebar-item>
                          <vs-sidebar-item
                            :to="'IndoorDashboard'"
                            index="3"
                            icon="dashboard"
                          >
                            Resource Dashboard
                          </vs-sidebar-item>
                          <vs-sidebar-item
                            :to="'thingsboard'"
                            index="3"
                            icon="stream"
                          >
                            Sensor Dashboard
                          </vs-sidebar-item>
                          <!-- <vs-sidebar-item :to="'3dtest'" index="3" icon="3d_rotation">
          3D model
        </vs-sidebar-item> -->
                          <vs-sidebar-group title="Resource Mangement">
                            <vs-sidebar-item
                              :to="'IndoorTag'"
                              index="2.1"
                              icon="loyalty"
                            >
                              Worker Tag
                            </vs-sidebar-item>
                            <vs-sidebar-item
                              :to="'IndoorGateway'"
                              index="2.3"
                              icon="router"
                            >
                              Gateway
                            </vs-sidebar-item>
                          </vs-sidebar-group>
                        </vs-sidebar-group>
                        <vs-sidebar-group
                          title="Sentenance"
                          v-if="sideindex[3]"
                          open
                        >
                          <template
                            v-for="(sidebarLink, index) in sidebarLinks.slice(
                              sideindex[2],
                              sideindex[3]
                            )"
                          >
                            <div
                              v-if="
                                username == 'frasers.kho' ||
                                username == 'frasers.roj' ||
                                username == 'frasers.ban'
                              "
                              :key="index"
                            >
                              <vs-sidebar-item
                                v-if="
                                  sidebarLink.name != 'Map' &&
                                  sidebarLink.name != 'Dashboard' &&
                                  sidebarLink.name != 'Custom Dashboard'
                                "
                                :icon="sidebarLink.icon"
                                :to="sidebarLink.url"
                                :key="`sidebarLink-${index}`"
                                :index="index"
                              >
                                <span class="hide-in-minisidebar" id="stfont">{{
                                  sidebarLink.name
                                }}</span>
                              </vs-sidebar-item>
                            </div>
                            <div
                              v-else-if="
                                username == 'betagrodemo' ||
                                admin == 'betagrodemo' ||
                                username == 'lindedemo' ||
                                username.match('enco') ||
                                username == 'swiftdemo' ||
                                username == 'smarthome' ||
                                username == 'birchteladmin' ||
                                username == 'truedigital' ||
                                admin == 'birchteladmin'
                              "
                              :key="index"
                            >
                              <vs-sidebar-item
                                v-if="
                                  sidebarLink.name != 'Map' &&
                                  sidebarLink.name != 'Custom Dashboard'
                                "
                                :icon="sidebarLink.icon"
                                :to="sidebarLink.url"
                                :key="`sidebarLink-${index}`"
                                :index="index"
                              >
                                <span class="hide-in-minisidebar" id="stfont">{{
                                  sidebarLink.name
                                }}</span>
                              </vs-sidebar-item>
                            </div>
                            <div v-else :key="index">
                              <vs-sidebar-item
                                v-if="
                                  sidebarLink.name != 'Dashboard' &&
                                  sidebarLink.name != 'Custom Dashboard'
                                "
                                :icon="sidebarLink.icon"
                                :to="sidebarLink.url"
                                :key="`sidebarLink-${index}`"
                                :index="index"
                              >
                                <span class="hide-in-minisidebar" id="stfont">{{
                                  sidebarLink.name
                                }}</span>
                              </vs-sidebar-item>
                            </div>
                          </template>
                          <!---Group Manager-->
                          <vs-sidebar-group title="Device Management">
                            <template
                              v-for="(sidebarLink, index) in sidebarLinks.slice(
                                sideindex[4],
                                sideindex[5]
                              )"
                            >
                              <vs-sidebar-item
                                :icon="sidebarLink.icon"
                                :to="sidebarLink.url"
                                :key="`sidebarLink-${index}`"
                                :index="index"
                              >
                                <span class="hide-in-minisidebar" id="stfont">{{
                                  sidebarLink.name
                                }}</span>
                              </vs-sidebar-item>
                            </template>
                          </vs-sidebar-group>
                          <!---Group Work-->
                          <vs-sidebar-group
                            title="Manage Work"
                            v-if="sideindex[7]"
                          >
                            <vs-sidebar-item
                              v-for="(sidebarLink, index) in sidebarLinks.slice(
                                sideindex[6],
                                sideindex[7]
                              )"
                              :icon="sidebarLink.icon"
                              :to="sidebarLink.url"
                              :key="`sidebarLink-${index}`"
                              :index="index"
                            >
                              <span class="hide-in-minisidebar" id="stfont">{{
                                sidebarLink.name
                              }}</span>
                            </vs-sidebar-item>
                          </vs-sidebar-group>
                          <!---Sidebar-->
                          <vs-sidebar-group
                            title="Setting"
                            v-if="admin == username"
                          >
                            <vs-sidebar-item
                              v-for="(sidebarLink, index) in sidebarLinks.slice(
                                sideindex[8],
                                sideindex[9]
                              )"
                              :icon="sidebarLink.icon"
                              :to="sidebarLink.url"
                              :key="`sidebarLink-${index}`"
                              :index="index"
                            >
                              <span class="hide-in-minisidebar" id="stfont">{{
                                sidebarLink.name
                              }}</span>
                            </vs-sidebar-item>
                          </vs-sidebar-group>
                        </vs-sidebar-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Enco -->
      <div
        v-if="username === 'Rivacold01' || this.admin === 'Rivacold01'"
        class="footer-sidebar center"
        slot="footer"
      >
        <div style="margin: 8px; text-align: center">
          <h5
            style="font-size: 0.8rem; font-weight: 550; color: rgb(91, 87, 119)"
          >
            Powered by<img
              class="ml-1"
              src="../../../assets/images/logo/swift_logo (1).png"
              style="width: 30%"
            />
          </h5>
        </div>
      </div>
      <div
        v-if="username === 'yamahademo'"
        class="footer-sidebar center"
        slot="footer"
      >
        <div style="margin: 8px; text-align: center">
          <h5
            style="font-size: 0.8rem; font-weight: 550; color: rgb(91, 87, 119)"
          >
            Powered by<img
              class="ml-1"
              src="../../../assets/images/logo/swift_logo (1).png"
              style="width: 30%"
            />
          </h5>
        </div>
      </div>

      <!-- Enco -->
      <div
        v-if="username.match('enco')"
        class="footer-sidebar center"
        slot="footer"
      >
        <div style="margin: 8px; text-align: center">
          <h5
            style="font-size: 0.8rem; font-weight: 550; color: rgb(91, 87, 119)"
          >
            Powered by<img
              class="ml-1"
              src="../../../assets/images/logo/swift_logo (1).png"
              style="width: 30%"
            />
          </h5>
        </div>
      </div>
      <!-- Sriboonrueng -->
      <div
        v-if="
          username.match('birchteladmin') ||
          username == 'nt' ||
          username == 'sbr'
        "
        class="footer-sidebar center"
        slot="footer"
      >
        <div style="margin: 8px; text-align: center">
          <h5
            style="font-size: 0.8rem; font-weight: 550; color: rgb(91, 87, 119)"
          >
            Powered by<img
              class="ml-1"
              src="../../../assets/images/logo/swift_logo (1).png"
              style="width: 30%"
            />
          </h5>
        </div>
      </div>
      <div class="footer-sidebar center" slot="footer">
        <vs-button
          class="primary mt-2 mb-3"
          @click="logout"
          icon="logout"
          type="filled"
          id="btnbackover"
        >
          <h6 class="stfont">Log Out</h6>
        </vs-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
export default {
  name: "SideBar",
  props: {
    parent: {
      type: String,
    },
    sidebarLinks: {
      type: Array,
      required: true,
    },
    sidebarLinks_dashboard: {
      type: Array,
      required: true,
    },
    index: {
      default: null,
      type: [String, Number],
    },
  },
  data: () => ({
    doNotClose: false,
    admin: "",
    windowWidth: window.innerWidth,
    username: "",
    admin: "",
    openItems: true,
  }),
  computed: {
    sideindex() {
      // console.log(this.$session.get('package'))
      switch (this.$session.get("package")) {
        case 0:
          return [0, 0, 0, 6, 7, 8, 0, 0, 15, 15];
        case 1:
          return [0, 0, 0, 6, 7, 10, 10, 13, 13, 18];
        case 2:
          return [0, 0, 0, 2, 7, 8, 0, 0, 16, 19];
        case 3:
          return [0, 0, 0, 4, 7, 8, 0, 0, 17, 19];
        case 4:
          return [0, 0, 0, 6, 7, 10, 10, 13, 13, 18, 18, 21, 24, 26, 27];
        case 5:
          return [0, 0, 0, 6, 7, 10, 0, 0, 13, 17];
        case 6:
          return [0, 0, 0, 6, 7, 10, 0, 0, 13, 17, 18, 21, 24, 26, 27];
        case 7:
          return [0, 0, 0];
        case 8:
          return [18, 23, 0, 0, 6, 9, 9, 11, 11, 15, 18, 21, 24, 26, 27];
        case 9:
          return [18, 23, 0, 0, 6, 9, 9, 11, 11, 15, 18, 21, 24, 26, 27];
        case 10:
          return [18, 23, 0, 0, 6, 9, 9, 11, 11, 15, 18, 21, 24, 26, 27];
        case 11:
          return [0, 0, 0, 5, 7, 10, 0, 0, 13, 16];
        default:
          return [0, 0, 0, 3, 7, 8, 0, 0, 14, 16];
      }
      // if(this.$session.get('package')) {
      //   return [0,4,4,7,7,8,8,15]
      // }else{
      //   return [0,3,4,5,0,0,9,11]
      // }
    },
    //This is for mobile trigger
    isSidebarActive: {
      get() {
        return this.$store.state.isSidebarActive;
      },
      set(val) {
        this.$store.commit("IS_SIDEBAR_ACTIVE", val);
      },
    },
  },
  watch: {},
  methods: {
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebar();
    },
    setSidebar() {
      if (this.windowWidth < 1170) {
        this.$store.commit("IS_SIDEBAR_ACTIVE", false);
        this.doNotClose = false;
      } else {
        this.$store.commit("IS_SIDEBAR_ACTIVE", true);
        this.doNotClose = true;
      }
    },
    logout() {
      this.sideindex = [];
      this.$session.clear();
      this.$router.push({
        name: "Login",
      });
    },
  },
  mounted() {
    // // console.log('SPEAK')
    // // console.log(this.$session.get('package'))
    // if(!this.$session.get('package')) {
    //   this.sideindex = [0,4,4,7,7,9,9,15]
    // }else{
    //   this.sideindex = [0,2,4,6,0,0,9,11]
    // }
    this.admin = this.$session.get("admin");
    this.username = this.$session.get("username");
    this.admin = this.$session.get("admin");
    console.log(this.username, this.admin);
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);
    });
    this.setSidebar();
    switch (this.username || this.admin) {
      case "betagrodemo":
        console.log("betagrodemo");
        // var element = document.getElementsByClassName('vs-sidebar--items');
        // element.classList.add("mystyle");
        var elemnavbar = document.getElementsByClassName("vs-sidebar");
        Array.prototype.filter.call(elemnavbar, function (testElement) {
          testElement.style.background = "#212121";
          // testElement.style.height = '100%';
        });
        // document.getElementById("stfont").style.color = "#ffffff";

        var fontColor1 = document.getElementsByClassName("hide-in-minisidebar");
        Array.prototype.filter.call(fontColor1, function (testElement2) {
          testElement2.style.color = "#ffffff";
        });
        var fontColor2 = document.getElementsByClassName("vs-sidebar-group");
        Array.prototype.filter.call(fontColor2, function (testElement3) {
          testElement3.style.color = "#ffffff";
        });

        var fontColor3 = document.getElementsByClassName("vs-sidebar--items");
        Array.prototype.filter.call(fontColor3, function (testElement4) {
          testElement4.style.color = "#ffffff";
        });
        var fontColor4 = document.getElementsByClassName("h4");
        Array.prototype.filter.call(fontColor4, function (testElement5) {
          testElement5.style.color = "#ffffff";
        });
        // console.log('aaaaaaaaaaaaaaaaaaaaaaaaaa')
        break;
      case "pttdemo":
        console.log("pttdemo");

        break;
      default:
        console.log("Try looking up for a hint.");
    }
  },
  beforeDestroy() {
    this.sideindex = [];
    this.$session.clear();
    window.removeEventListener("resize", this.handleWindowResize);
    this.setSidebar();
  },
};
</script>

<style>
.mystyle {
  background: red;
  height: 100%;
}
#stfont {
  /*font-size 14px */
  font-size: 0.875rem;
  font-family: Arial, Helvetica, sans-serif;
}
.vs-sidebar-group.vs-sidebar-group-open > h4 {
  font-size: 88%;
  font-weight: lighter;
  font-family: Arial, Helvetica, sans-serif;
  color: #6c757d;
}
.vs-sidebar-group > h4 {
  font-size: 88%;
  font-weight: lighter;
  font-family: Arial, Helvetica, sans-serif;
  color: #6c757d;
}
.vs-sidebar {
  /*font-size 12px */
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  text-indent: 7px;
}
.vs-sidebar-group.vs-sidebar-group-open > h4:hover {
  font-size: 88%;
  font-weight: lighter;
  font-family: Arial, Helvetica, sans-serif;
  color: #47c93c;
  /* background: #48C93B; */
  /* background: #28a745;;
   color: aliceblue; */
}
.vs-sidebar-group > h4:hover {
  font-size: 88%;
  font-weight: lighter;
  font-family: Arial, Helvetica, sans-serif;
  /* color: aliceblue; */
  color: #48c93b;
  /* background: #48C93B;
  background: #28a745;; */
}
.vuesax-app-is-ltr .vs-sidebar-group h4 i {
  right: 10px;
  top: 5.5px;
}
.vs-sidebar-group.vs-sidebar-group-open > h4 {
  color: aliceblue;
  margin: 6px;
  border-radius: 20px;
  background: #48c93b;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
.vs-sidebar-group.vs-sidebar-group-open > h4:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  color: aliceblue;
}
#btnbackover {
  margin: 0px 5px 0px 10px;
  border-radius: 30px;
  display: flex;
  width: 90%;
  background-color: #4caf50;
  align-items: center;
}
#parentx {
  background: #47c93c;
}
</style>
